import { makeStyles } from '@material-ui/core/styles';

export const useCostReportExportModalStyles = makeStyles((theme) => ({
    modalContent: {
        padding: theme.spacing(2),
        minWidth: 560,
    },
    section: {
        marginBottom: theme.spacing(3),
    },
    sectionLabel: {
        fontWeight: 600,
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
        fontSize: '0.85rem',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
    },
    presetGroup: {
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1.5),
    },
    presetButton: {
        flex: 1,
    },
    dateRow: {
        display: 'flex',
        gap: theme.spacing(2),
    },
    dateField: {
        flex: 1,
    },
    categoriesGrid: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
    },
    categoryRow: {
        display: 'flex',
        alignItems: 'center',
    },
    categoryLabel: {
        fontSize: '0.95rem',
    },
    allNoneRow: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(0.5),
    },
    allNoneButton: {
        fontSize: '0.78rem',
        padding: theme.spacing(0, 1),
        minWidth: 0,
    },
    divider: {
        margin: theme.spacing(0, 0, 2, 0),
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
        paddingTop: theme.spacing(2),
    },
    exportTriggerButton: {
        marginRight: theme.spacing(1.5),
    },
}));
